import { TicketPriority } from '@outlaw-oasis/types';
import { AlertTriangle } from 'lucide-react';

interface TicketPriorityBadgeProps {
  priority: TicketPriority;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}

const priorityConfig: Record<TicketPriority, { label: string; className: string }> = {
  low: {
    label: 'Low',
    className: 'bg-gray-500/20 text-gray-400',
  },
  medium: {
    label: 'Medium',
    className: 'bg-blue-500/20 text-blue-400',
  },
  high: {
    label: 'High',
    className: 'bg-orange-500/20 text-orange-400',
  },
  urgent: {
    label: 'Urgent',
    className: 'bg-red-500/20 text-red-400 animate-pulse',
  },
};

export function TicketPriorityBadge({ priority, size = 'md', showIcon = false }: TicketPriorityBadgeProps) {
  const config = priorityConfig[priority];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center gap-1 rounded-full font-medium ${config.className} ${sizeClasses}`}>
      {showIcon && priority === 'urgent' && <AlertTriangle className="w-3 h-3" />}
      {config.label}
    </span>
  );
}
